import { Typography } from '@mui/material'

export const TabLabel = ({ label }) => {
  //   const widths = [320, 375, 700, 800, 999, 1000, 1440]
  //   const results = widths.map(w => [w, clamp2840(w)])
  //   console.table(results)
  //   console.log('breakpoints:', clampBreakpoints(28, 4, 40))
  return <Typography sx={{ fontSize: 'clamp(10px, 1.6vw, 13px)' }}>{label}</Typography>
}
